<script lang="ts">
	// Supports weights 100-700
	import '@fontsource-variable/ibm-plex-sans';
	
	import '../app.css';
	import { page } from '$app/state';
	//import { webVitals } from '$lib/vitals';
	import { invalidate } from '$app/navigation';
	import { onMount } from 'svelte';

	import { AppBar, Navigation } from '@skeletonlabs/skeleton-svelte';
	import IconMenu from 'lucide-svelte/icons/menu';
	import IconHome from 'lucide-svelte/icons/house';
	import IconRecipes from 'lucide-svelte/icons/cooking-pot';
	//import IconPlanner from 'lucide-svelte/icons/calendar-clock';
	import IconEdit from 'lucide-svelte/icons/file-pen-line';
	import IconCreate from 'lucide-svelte/icons/file-plus';
	import IconAccount from 'lucide-svelte/icons/square-user-round';

	let { data, children } = $props();
	let { session, supabase } = $derived(data);

	///
	/// @TODO: We need to reenable webvitals
	///
	// $effect(() => {
	// 	if (data?.analyticsId) {
	// 		webVitals({
	// 			path: page.url.pathname,
	// 			params: page.params,
	// 			analyticsId: data.analyticsId
	// 		});
	// 	}
	// });

	let metaTitle = $derived(page.data?.metaTitle || 'Todays Recipes');
	let metaDescription = $derived(page.data?.metaDescription || 'Todays Recipes Website');

	interface NavOption {
		id: string;
		label: string;
		labelExpanded: string;
		href: string;
		icon: typeof IconHome;
	}

	let navOptions = $derived.by<NavOption[]>(() => {
		let options: NavOption[] = [
			{
				id: '0',
				label: 'Home',
				labelExpanded: 'Home',
				href: '/',
				icon: IconHome
			},
			{
				id: '1',
				label: 'Recipes',
				labelExpanded: 'All Recipes',
				href: '/recipes/search',
				icon: IconRecipes
			}
			///
			/// @todo: This is currently unavailable
			///
			// {
			// 	id: '2',
			// 	label: 'Planner',
			// 	labelExpanded: 'Meal Planner',
			// 	href: '/planner',
			// 	icon: IconPlanner
			// }
		];

		if (session) {
			options = [
				...options,
				{
					id: '3',
					label: 'Edit',
					labelExpanded: 'Edit',
					href: '/private/edit',
					icon: IconEdit
				},
				{
					id: '4',
					label: 'AI Creation',
					labelExpanded: 'AI Creation',
					href: '/private/random',
					icon: IconCreate
				},
				{
					id: '5',
					label: 'Account',
					labelExpanded: 'Account',
					href: '/private/account',
					icon: IconAccount
				}
			];
		}

		return options;
	});

	let title = 'Todays Recipe';
	let byLine = 'AI integrated recipe design and meal planning';
	let navVisible = $state(false);
	let selected = $state('0');

	onMount(() => {
		const { data } = supabase.auth.onAuthStateChange((_, newSession) => {
			if (newSession?.expires_at !== session?.expires_at) {
				invalidate('supabase:auth');
			}
		});

		return () => data.subscription.unsubscribe();
	});
</script>

<svelte:head>
	<title>{metaTitle}</title>
	<meta name="description" content={metaDescription} />
	<script async src="https://www.googletagmanager.com/gtag/js?id=G-B3KYVDYGSS"></script>
	<script>
		window.dataLayer = window.dataLayer || [];
		function gtag() {
			dataLayer.push(arguments);
		}
		gtag('js', new Date());

		gtag('config', 'G-B3KYVDYGSS');
	</script>
</svelte:head>

<div class="flex h-screen flex-col">
	<!-- Header -->
	<AppBar
		classes="sticky top-0 z-50 border border-surface-200-800/30 backdrop-blur-lg"
		background="bg-surface-100-900/75"
		leadClasses="hidden sm:block"
		headlineClasses="block sm:hidden"
		centerClasses="hidden sm:block"
	>
		{#snippet lead()}
			<div class="flex h-full w-full flex-col justify-center">
				<button
					type="button"
					class="btn-icon preset-filled-primary-100-900"
					onclick={() => (navVisible = !navVisible)}
				>
					<IconMenu size={24} />
				</button>
			</div>
		{/snippet}
		{#snippet headline()}
			<h1 class="h1">{title}</h1>
		{/snippet}
		<h1 class="h1">{title}</h1>
		<h3 class="h3 pt-2">{byLine}</h3>
	</AppBar> 

	<div class="relative flex flex-1 overflow-hidden card border-surface-100-900">
		{#if navVisible}
			<Navigation.Rail
				classes="sticky top-0 h-full w-[20rem] shrink-0 z-40 hidden sm:block"
				tilesJustify="justify-start"
				value={selected}
				expanded
			>
				{#snippet tiles()}
					{#each navOptions as option}
						<Navigation.Tile {...option} onclick={() => (selected = option.id)}>
							<option.icon />
						</Navigation.Tile>
					{/each}
				{/snippet}
			</Navigation.Rail>
		{/if}
		<main class="flex-1 overflow-y-auto">
			{@render children()}
		</main>
	</div>
	<footer class="sticky bottom-0 z-50 sm:hidden card border-surface-100-900">
		<Navigation.Bar classes="block sm:hidden" value={selected}>
			{#each navOptions as option}
				<Navigation.Tile {...option} onclick={() => (selected = option.id)}>
					<option.icon />
				</Navigation.Tile>
			{/each}
		</Navigation.Bar>
	</footer> 
</div>
